import { render, staticRenderFns } from "./BottomOfPaymentPage.vue?vue&type=template&id=b5656332&scoped=true&"
import script from "./BottomOfPaymentPage.vue?vue&type=script&lang=js&"
export * from "./BottomOfPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./BottomOfPaymentPage.vue?vue&type=style&index=0&id=b5656332&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5656332",
  null
  
)

export default component.exports